<template>
  <div>
    <v-text-field
      :label="labelString"
      prepend-inner-icon="mdi-magnify"
      v-model="searchString"
      variant="solo"
      density="compact"
      class="hideDetails rounded-lg"
      :class="{
        backgroundInputColor: dark,
      }"
      flat
      :disabled="disabled"
      autocomplete="off"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "searchBar",

  props: ["labelArray", "dark", "disabled"],

  data() {
    return {
      searchString: "",
    };
  },

  computed: {
    labelString() {
      let result = "";

      if (this.labelArray) {
        for (let i = 0; i < this.labelArray.length; i++) {
          result += this.$t(this.labelArray[i]);

          if (i < this.labelArray.length - 1) {
            result += ", ";
          }
        }
      }

      return result;
    },
  },

  watch: {
    searchString(newVal, oldVal) {
      if (newVal.length > 1) {
        this.$emit("search", this.getEscapedSearchString());
      } else if (oldVal && oldVal.length > 1) {
        this.$emit("search", "");
      }
    },
  },

  methods: {
    getEscapedSearchString(){
      return encodeURIComponent(this.searchString)
    }
  }
};
</script>
